import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';

import ListaMultiNivel from '../../atomicos/ListaMultiNivel';
import BuscadorArboles from '../../atomicos/BuscadorArboles';
import Collapse from '@material-ui/core/Collapse';

import {hidden} from '../../../common/helpers';

function MenuModulos({
   modulos,
   mapaModulo,
   listaMultiNivelProps,
   incluirBuscador,
   buscadorProps,
   dividerProps,
   hide,
   ...rest
}) {
   const isHideFuntion = typeof hide === 'function';
   function hideFunction(item) {
      if (isHideFuntion) {
         return hide(item);
      }
      return false;
   }
   return (
      <div {...rest}>
         <Collapse
            style={{
               marginBottom: '8px'
            }}
            in={incluirBuscador}
         >
            <BuscadorArboles {...buscadorProps} arboles={modulos} mapaArbol={mapaModulo} />
         </Collapse>
         <Divider {...dividerProps} />
         {modulos.map((item, index) => {
            if (hidden(item)) {
               return null;
            }
            if (hideFunction(item)) {
               return null;
            }
            return (
               <div key={index}>
                  <ListaMultiNivel
                     {...listaMultiNivelProps}
                     arbol={item}
                     mapaArbol={mapaModulo}
                     hide={hideFunction}
                  />
                  <Divider {...dividerProps} />
               </div>
            );
         })}
      </div>
   );
}

MenuModulos.propTypes = {
   modulos: PropTypes.arrayOf(PropTypes.object),
   mapaModulo: PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      icono: PropTypes.string.isRequired,
      nodos: PropTypes.string.isRequired,
      valorIgnorar: PropTypes.string.isRequired
   }),
   listaMultiNivelProps: PropTypes.object,
   incluirBuscador: PropTypes.bool,
   buscadorProps: PropTypes.object,
   dividerProps: PropTypes.object,
   /** Función que determina si un node es visible, con la siguiente firma:
    *
    * - `arbol`: objeto, con la misma forma a los del array de la propiedad __modulos__.
    * - `retorno`: boolean, si es __true_ el nodo no sera renderizado.
    * */
   hide: PropTypes.func
};

export default MenuModulos;
